import './form.css';
type InputFormProps = React.HtmlHTMLAttributes<HTMLFormElement>;

export function InputForm(props: InputFormProps) {
  const {className: passedClasses, ...rest} = props;
  const className = passedClasses + ' form';
  return <form {...rest} className={className}></form>
}